/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

const icons: Record<string, (props: React.SVGProps<SVGSVGElement>) => JSX.Element> = {
  roundedCheckmark: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="30" cy="30" r="30" fill="#2FAEF3" />
      <path
        d="M15.7634 31.7518C13.5285 29.5168 16.6946 26.1645 18.9295 28.2131L25.2618 34.1729L37.9264 20.7634C40.1613 18.5285 43.5137 21.6946 41.465 23.9295L26.938 39.2015C26.0068 40.1327 24.7031 40.319 23.5856 39.3878L15.7634 31.7518Z"
        fill="white"
      />
    </svg>
  ),
  checkmark: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21" {...props}>
      <path
        d="M23.034 1.974 10.328 14.658 4.39 8.496a2.003 2.003 0 0 0-2.903-.01 2.179 2.179 0 0 0-.003 3.002l7.387 7.632c.366.42.894.649 1.44.623a2.26 2.26 0 0 0 1.429-.578L25.866 5.056a2.17 2.17 0 0 0 .106-2.967 2.07 2.07 0 0 0-2.938-.115Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  ),
  loader: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="40"
      height="40"
      viewBox="0 0 50 50"
      {...props}
    >
      <path
        fill="currentColor"
        d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  ),
  close: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.7327 24.5C22.2602 24.4968 21.8076 24.3096 21.471 23.9781L1.04789 3.55501C0.722644 3.22316 0.539737 2.77749 0.538097 2.31283C0.536457 1.84817 0.716214 1.40121 1.03911 1.06708C1.36201 0.732942 1.80256 0.538008 2.267 0.523758C2.73145 0.509509 3.18312 0.67707 3.52589 0.990783L3.57128 1.03163L23.9943 21.4547C24.2418 21.705 24.4099 22.0227 24.4775 22.3681C24.5452 22.7135 24.5094 23.0712 24.3747 23.3963C24.24 23.7215 24.0123 23.9996 23.7202 24.196C23.4281 24.3923 23.0846 24.4981 22.7327 24.5Z"
        fill="currentColor"
        stroke="currentColor"
      />
      <path
        d="M2.28194 24.4864C1.92938 24.487 1.58461 24.3828 1.29137 24.1871C0.99814 23.9914 0.769673 23.7129 0.634972 23.3871C0.500271 23.0613 0.46541 22.7028 0.534815 22.3571C0.604219 22.0115 0.774759 21.6942 1.02479 21.4457L21.4479 1.02261C21.7825 0.687988 22.2363 0.5 22.7096 0.5C23.1828 0.5 23.6366 0.687988 23.9712 1.02261C24.3059 1.35723 24.4939 1.81108 24.4939 2.2843C24.4939 2.75753 24.3059 3.21137 23.9712 3.54599L3.54817 23.9691C3.38214 24.1352 3.18463 24.2665 2.9672 24.3554C2.74977 24.4442 2.51681 24.4888 2.28194 24.4864Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  ),
  arrowDown: (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  ),
  arrowNext: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.712 9.73599L2.70401 16.744C2.29601 17.128 1.67201 17.128 1.28801 16.744C0.904009 16.36 0.904009 15.736 1.28801 15.328L7.6 9.01599L1.28801 2.70399C0.90401 2.31999 0.90401 1.67199 1.28801 1.28799C1.67201 0.903995 2.29601 0.903995 2.70401 1.28799L9.712 8.31999C10.096 8.70399 10.096 9.32799 9.712 9.73599Z"
        strokeWidth="1.5"
      />
    </svg>
  ),
  goBack: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
      <circle cx="25" cy="25" r="24" fill="#EEFBFF" stroke="#2FAEF3" strokeWidth="2" />
      <path
        d="M33.55 23.589a1.44 1.44 0 0 0-.248-.019H19.12l.31-.143c.302-.143.577-.338.812-.576l3.977-3.977c.524-.5.612-1.304.209-1.906a1.439 1.439 0 0 0-2.158-.187l-7.192 7.192a1.439 1.439 0 0 0 0 2.036l7.192 7.192a1.438 1.438 0 0 0 2.158-.144 1.489 1.489 0 0 0-.209-1.906l-3.97-3.985a2.878 2.878 0 0 0-.719-.524l-.431-.195h14.125a1.489 1.489 0 0 0 1.517-1.208 1.439 1.439 0 0 0-1.19-1.65Z"
        fill="#2FAEF3"
      />
    </svg>
  ),
  creditCard: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 16" {...props}>
      <path
        d="M.998 0A.986.986 0 0 0 0 1.001V4h24.993V1.001A.988.988 0 0 0 23.995 0H.998ZM0 6.498v8.5A.988.988 0 0 0 .998 16h22.997a.986.986 0 0 0 .998-1.001V6.498H0Zm19.497 3.75h3v3h-3v-3Zm-16.518 2h4.997v1H2.979v-1Z"
        fill="#6D6D6D"
      />
    </svg>
  ),
  tabDropdown: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5 8L0.669872 0.499999L9.33013 0.5L5 8Z" fill="#303030" />
    </svg>
  ),
  sendMsg: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      width="14"
      height="14"
      {...props}
    >
      <path d="M13.066 6.997a.883.883 0 0 0-.132-.464.856.856 0 0 0-.353-.321L1.22.682a.832.832 0 0 0-.958.164.886.886 0 0 0-.183.975l1.973 4.541a1.6 1.6 0 0 1 0 1.27L.083 12.17a.875.875 0 0 0 .162.977.825.825 0 0 0 .958.164L12.56 7.79a.854.854 0 0 0 .368-.32.883.883 0 0 0 .139-.472ZM2.986 5.94l-1.792-4.1 9.557 4.638h-7.6a2.91 2.91 0 0 0-.166-.538Zm-1.792 6.21 1.791-4.09c.076-.171.132-.351.168-.535h7.6L1.195 12.15Z" />
    </svg>
  ),
  thickDropdown: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      fill="none"
      width="8"
      height="9"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 8"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.486 7.447.15 1.667A1.114 1.114 0 0 1 1.111 0h6.675c.85 0 1.388.93.962 1.667l-3.337 5.78c-.425.737-1.5.737-1.925 0Z"
        fill="#303030"
      />
    </svg>
  ),
  chatBubble: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      {...props}
    >
      <path
        d="M16.466 0H2.496A2.502 2.502 0 0 0 0 2.496v9.55a2.502 2.502 0 0 0 2.496 2.496h9.87l4.832 3.275c.184.137.413.183.619.183.183 0 .366-.046.526-.137a1.13 1.13 0 0 0 .596-.985V2.496A2.454 2.454 0 0 0 16.466 0Z"
        fill="#fff"
      />
    </svg>
  ),
  contextMenu: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z" />
      <path d="M3 18C4.65685 18 6 16.6569 6 15C6 13.3431 4.65685 12 3 12C1.34315 12 0 13.3431 0 15C0 16.6569 1.34315 18 3 18Z" />
      <path d="M15 6C16.6569 6 18 4.65685 18 3C18 1.34315 16.6569 0 15 0C13.3431 0 12 1.34315 12 3C12 4.65685 13.3431 6 15 6Z" />
      <path d="M15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C13.3431 12 12 13.3431 12 15C12 16.6569 13.3431 18 15 18Z" />
    </svg>
  ),
  needHelp: (props: React.SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
      <circle cx="13" cy="13" r="13" fill="#303030" />
      <circle cx="13" cy="13" r="13" fill="#000" fillOpacity=".2" />
      <path
        d="m12.846 7.005.244.022a4.753 4.753 0 0 1 1.745.453c.49.225.906.581 1.204 1.03.228.353.368.754.41 1.172.047.361.018.728-.086 1.077-.13.417-.354.797-.656 1.112a7.486 7.486 0 0 1-1.132.93c-.226.156-.428.319-.64.482-.193.159-.338.368-.42.604-.044.122-.097.245-.144.367a.843.843 0 0 1-.788.559 1.102 1.102 0 0 1-.572-.09.936.936 0 0 1-.514-.7 1.607 1.607 0 0 1 .272-1.2c.195-.286.435-.54.71-.751.297-.242.602-.473.906-.715.251-.193.462-.434.62-.709a1.328 1.328 0 0 0-.159-1.47 1.222 1.222 0 0 0-.679-.376 2.161 2.161 0 0 0-1.054.018 1.284 1.284 0 0 0-.817.679c-.107.199-.2.403-.3.604-.072.152-.171.29-.291.41a1.012 1.012 0 0 1-.767.246 1.062 1.062 0 0 1-.485-.13.837.837 0 0 1-.452-.748 2.19 2.19 0 0 1 .452-1.385 3.49 3.49 0 0 1 1.358-1.1 4.142 4.142 0 0 1 1.288-.371L12.352 7l.494.005ZM12.396 19c-.068-.014-.136-.025-.202-.043a1.254 1.254 0 1 1 .543.02l-.11.023h-.231Z"
        fill="#fff"
      />
    </svg>
  ),
  clock: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z"
      />
    </svg>
  ),
  exclamation: (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" {...props}>
      <g clipPath="url(#a)" fill="currentColor">
        <path d="M14.665 7.556a2.278 2.278 0 0 1 .463 1.89l-1.001 5.005a1.251 1.251 0 1 1-2.503 0l-1-5.005a2.276 2.276 0 0 1 .462-1.89 2.353 2.353 0 0 1 3.58 0ZM12.9 19.23a1.251 1.251 0 1 0 0-2.502 1.251 1.251 0 0 0 0 2.503Z" />
      </g>
    </svg>
  ),
  addPlusSign: (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="15" height="15" viewBox="0 0 15 15" {...props} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66756 0.745422V6.6675H0.745483V8.64153H6.66756V14.5636H8.64159V8.64153H14.5637V6.6675H8.64159V0.745422H6.66756Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export default icons;
